import { ValidatorFn, Validators } from '@angular/forms';
import { TypedAbstractControl } from '@principle-theorem/ng-shared';
import { AccBooleanValue } from '@principle-theorem/principle-core/interfaces';

export function hasRequiredError(
  control: TypedAbstractControl<unknown>
): boolean {
  return control.hasError('required') && control.touched;
}

export function setRequiredValidation(
  value: AccBooleanValue | boolean,
  control: TypedAbstractControl<unknown>,
  setValue: undefined | string | number | [] = undefined,
  preserveValidators: ValidatorFn[] = []
): void {
  if (value === AccBooleanValue.True || value === true) {
    control.setValidators([Validators.required, ...preserveValidators]);
  } else {
    control.clearValidators();
    if (preserveValidators.length) {
      control.setValidators(preserveValidators);
    }
    control.setValue(setValue);
  }

  control.updateValueAndValidity();
}
